<template>
  <div
    :id="`component_wrapper-${index_component}`"
    contenteditable="false"
    data-name="specification"
    class="componentArticle_wrapper component_container specification-legacy-container"
  >
    <div class="componentArticle_wrapper__admin_controls-header">
      <CloseSVG
        alt="close"
        class="componentArticle_wrapper__admin_controls-header__img"
        @click="deleteLegacy()"
      />
    </div>

    <div class="specification-legacy-body">
      <v-icon color="orange" size="28" class="mr-2">mdi-alert-circle-outline</v-icon>
      <div>
        <div class="specification-legacy-title">Устаревший блок «Спецификация»</div>
        <div class="specification-legacy-hint">Удалите этот блок и вставьте «Примеры работ» вместо него</div>
      </div>
    </div>
  </div>
</template>

<script>
import CloseSVG from "@/assets/svg/closeIcon.svg";

export default {
  name: "SpecificationLegacyArticle",
  components: { CloseSVG },
  data: () => ({
    index_component: null,
    index_specification: null,
    specification_data: {},
  }),
  watch: {
    "$store.state.ArticleModule.selectedComponent": {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length && !this.specification_data.imageId) {
          this.getData();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      const selected = this.$store.state.ArticleModule.selectedComponent;
      if (!selected || !Object.keys(selected).length) return;

      this.index_specification = this.$store.state.ArticleModule.counters.specification;
      this.index_component = this.$store.state.ArticleModule.counters.layout;
      this.specification_data = { ...selected };
    },

    async deleteLegacy() {
      if (!confirm("Удалить устаревший блок спецификации из статьи?")) return;
      await this.$store.dispatch("deleteComponent", this.index_component);
    },
  },
};
</script>

<style lang="scss" scoped>
.specification-legacy-container {
  position: relative;
  padding: 0;
  margin: 20px 0;
  border: 2px dashed #fb8c00;
  border-radius: 8px;
  background: #fff8f0;
  cursor: default;
}

.specification-legacy-body {
  display: flex;
  align-items: center;
  padding: 16px 20px;
}

.specification-legacy-title {
  font-size: 14px;
  font-weight: 600;
  color: #e65100;
  margin-bottom: 2px;
}

.specification-legacy-hint {
  font-size: 13px;
  color: #888;
}
</style>